import React from 'react'
import dayjs from 'dayjs'
import { UserAvatar } from '@forwardflow/ui'
import { getAvatarColor } from '@forwardflow/helpers/utils'
import { message } from 'antd'
import useAuthUser from '@forwardflow/hooks/customHooks/useAuthUser'

interface MessageItemProps {
   item: any
   selectedLeadDetails: any
}

export const LeadMessageItem: React.FC<MessageItemProps> = ({
   item,
   selectedLeadDetails,
}) => {
   const { data: user } = useAuthUser({ revalidateOnMount: true })
   const handleCopy = () => {
      navigator.clipboard.writeText(item?.stepId).then(() => {
         message.success('Copied to clipboard')
      })
   }
   return (
      <div className="flex items-end justify-start gap-x-2">
         <UserAvatar
            backgroundColor={getAvatarColor(
               selectedLeadDetails?.stageInfo?.name
            )}
            className="!w-10 !h-10 !text-[14px]"
         >
            {selectedLeadDetails?.userInfo?.firstName.slice(0, 1) || 'L'}
         </UserAvatar>
         <div className="flex flex-col items-start gap-y-1">
            <div className="flex flex-col justify-between bg-white/10 py-4 px-5 max-w-[450px] rounded-3xl rounded-bl-none gap-y-1">
               {user?.email === 'operator@forward-flow.com' && item?.stepId && (
                  <div className="text-[11px] mb-1 text-white/70 flex gap-x-4">
                     <span
                        className="cursor-pointer select-all"
                        title="Click to copy"
                        onClick={handleCopy}
                     >
                        Step Id:{' '}
                        <span className="text-[12px] font-medium">
                           {item?.stepId}
                        </span>
                     </span>
                     {item?.campaignPhase && (
                        <span>
                           Phase:{' '}
                           <span className="text-[12px] font-medium">
                              {item?.campaignPhase}
                           </span>
                        </span>
                     )}
                     {item?.campaignType && (
                        <span>
                           Type:{' '}
                           <span className="text-[12px] font-medium">
                              {item?.campaignType}
                           </span>
                        </span>
                     )}
                  </div>
               )}
               <p className="text-[14px] font-medium">{item?.content}</p>

               <p className="text-[10px] text-white/70">
                  {dayjs(item?.ts).format('h:mm A, D MMM YYYY')}
               </p>
            </div>
            {item?.data?.objection?.content && (
               <div
                  className={`text-[12px] font-semibold h-6 flexc px-2 rounded-md ${
                     item?.data?.objection?.objectionType === 'negative'
                        ? 'bg-[#C11574]/20 text-[#E04D9E]'
                        : 'bg-[#0FF04E]/20 text-[#78F49B]'
                  } `}
               >
                  {item?.data?.objection?.objectionType === 'negative' && (
                     <> Objection - {item?.data?.objection?.content}</>
                  )}
                  {item?.data?.objection?.objectionType === 'positive' && (
                     <>Objection response - {item?.data?.objection?.rates}</>
                  )}
               </div>
            )}
         </div>
      </div>
   )
}
